import { pageLoader } from "./../../Public/assets/index";
import React from "react";

const Loader = ({ className = "" }) => {
  return (
    <div className={`flex justify-center items-center  ${className}`}>
      <img src={pageLoader} alt="Loading..." className={`${className}`} />
    </div>
  );
};

export default Loader;
